import { useSnackbar, VariantType } from 'notistack';

export function useSnackbarNotify(): (message: string, type?: VariantType) => void {
	const { enqueueSnackbar } = useSnackbar();
	return (message: string, type?: VariantType) => enqueueSnackbar(message, { preventDuplicate: true, variant: type ?? 'success' });
}
